import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { isNumeric } from './Utility';

function Input({ id, context, validationState, ...props }) {

  var verseDivStyle = {
    width: 50,
    float: 'left',
    marginTop: 8
  };

  return (<div style={verseDivStyle}>
    <FormGroup validationState={validationState}>
      <FormControl type="text" onChange={e => {
        if (isNumeric(e.target.value) || e.target.value === "") {
          var verse = context.state;
          verse[id] = e.target.value;
          context.setState(verse);
        }
      }} value={context.state[id] || ""} {...props} /></FormGroup>
  </div>);
}

class VerseGroup extends Component {

  constructor(props) {
    super(props);
    if (this.props.verse != null) {
      this.state = {
        book: this.props.verse.book,
        startChapter: this.props.verse.startChapter || "",
        startVerse: this.props.verse.startVerse || "",
        endVerse: this.props.verse.endVerse || "",
        endChapter: this.props.verse.endChapter || ""
      };
    }
    else {
      this.state = {
        book: 0,
        startChapter: "",
        startVerse: "",
        endVerse: "",
        endChapter: ""
      };
    }
  }

  render() {

    if (this.state != this.props.verse) {
      this.props.update(this.state, this.props.id);
    }

    var spanStyle = {
      float: 'left',
      marginTop: 13,
      width: 15,
      textAlign: 'center'
    };

    return (

      <FormGroup controlId={"verse" + this.props.id.toString()}>
        {this.props.title !== "" ? <ControlLabel>{this.props.title}</ControlLabel> : null}
        <div>
          <div style={{width: 125, float: 'left', marginTop: 8}}>
            <FormControl componentClass="select" placeholder="Genesis" onChange={e => { this.setState({book: parseInt(e.target.value)}); }} value={this.state.book}>
              <option value="0">Genesis</option>
              <option value="1">Exodus</option>
              <option value="2">Leviticus</option>
              <option value="3">Numbers</option>
              <option value="4">Deuteronomy</option>
              <option value="5">Joshua</option>
              <option value="6">Judges</option>
              <option value="7">Ruth</option>
              <option value="8">1 Samuel</option>
              <option value="9">2 Samuel</option>
              <option value="10">1 Kings</option>
              <option value="11">2 Kings</option>
              <option value="12">1 Chronicles</option>
              <option value="13">2 Chronicles</option>
              <option value="14">Ezra</option>
              <option value="15">Nehemiah</option>
              <option value="16">Esther</option>
              <option value="17">Job</option>
              <option value="18">Psalms</option>
              <option value="19">Proverbs</option>
              <option value="20">Ecclesiastes</option>
              <option value="21">Song of Solomon</option>
              <option value="22">Isaiah</option>
              <option value="23">Jeremiah</option>
              <option value="24">Lamentation</option>
              <option value="25">Ezekiel</option>
              <option value="26">Daniel</option>
              <option value="27">Hosea</option>
              <option value="28">Joel</option>
              <option value="29">Amos</option>
              <option value="30">Obadiah</option>
              <option value="31">Jonah</option>
              <option value="32">Micah</option>
              <option value="33">Nahum</option>
              <option value="34">Habakkuk</option>
              <option value="35">Zephaniah</option>
              <option value="36">Haggai</option>
              <option value="37">Zechariah</option>
              <option value="38">Malachi</option>
              <option value="39">Matthew</option>
              <option value="40">Mark</option>
              <option value="41">Luke</option>
              <option value="42">John</option>
              <option value="43">Acts</option>
              <option value="44">Romans</option>
              <option value="45">1 Corinthians</option>
              <option value="46">2 Corinthians</option>
              <option value="47">Galations</option>
              <option value="48">Ephesians</option>
              <option value="49">Philippians</option>
              <option value="50">Colossians</option>
              <option value="51">1 Thessalonians</option>
              <option value="52">2 Thessalonians</option>
              <option value="53">1 Timothy</option>
              <option value="54">2 Timothy</option>
              <option value="55">Titus</option>
              <option value="56">Phileman</option>
              <option value="57">Hebrews</option>
              <option value="58">James</option>
              <option value="59">1 Peter</option>
              <option value="60">2 Peter</option>
              <option value="61">1 John</option>
              <option value="62">2 John</option>
              <option value="63">3 John</option>
              <option value="64">Jude</option>
              <option value="65">Revelation</option>
            </FormControl>
          </div>
          <span style={spanStyle}>  </span>

          <Input id="startChapter" context={this} placeholder="Ch" validationState={this.state.startChapter ? "success" : (this.state.startVerse || this.state.endChapter ? "error" : null)} />
          <span style={spanStyle}> : </span>
          <Input id="startVerse" context={this} placeholder="Vr" validationState={this.state.startVerse ? "success" : null} />
          <span style={spanStyle}>  -  </span>
          <Input id="endChapter" context={this} placeholder="Ch" validationState={(this.state.endChapter && this.state.endChapter < this.state.startChapter) ? "error" : (this.state.endChapter ? "success" : null)} />
          <span style={spanStyle}> : </span>
          <Input id="endVerse" context={this} placeholder="Vr" validationState={(((this.state.endChapter && this.state.endChapter <= this.state.startChapter) || !this.state.endChapter) && this.state.endVerse && this.state.endVerse < this.state.startVerse) ? "error" : (this.state.endVerse ? "success" : null)} />

        </div>
        <br />
        <div style={{height: 10}} />

      </FormGroup>

    );
  }
}

export default VerseGroup;



/** WEBPACK FOOTER **
 ** ./src/util/VerseGroup.js
 **/